/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], () => {

	class GroupOptimizerBase {
		constructor(queryService, dataSources) {
			this.requests = [];
			this.queryService = queryService;
			this.dataSources = dataSources;
		}

		getId() {
			return undefined;
		}

		isApplicable(){
			return false;
		}

		buildExecutionGroups(requests) {
			const groups = {};
			const responseList = [];

			// group the queries into group that could be queried together
			requests.forEach(request => {
				const response = {};
				response.promise = new Promise((resolve, reject) => {
					response.resolve = resolve;
					response.reject = reject;
				});
				responseList.push(response.promise);
				const key = this.getRequestGroupKey(request);
				if (!groups[key]){
					groups[key] = [];
				}
				groups[key].push( { request, response } );
			});

			return { groups, responseList };
		}

		restoreId(id) {
			const index =  id.indexOf('_o');
			if (index !== -1){
				id = id.substring(0, index);
			}
			return id;
		}

		executeGroup() {
			return Promise.reject();
		}

		_getCompareString(object, excludeAttributes) {
			let compareString = '';
			if (typeof object === 'object') {
				const compareValues = [];
				if (Array.isArray(object)) {
					object.forEach((value) => {
						compareValues.push(this._getCompareString(value, excludeAttributes));
					});
				} else {
					let name;
					for (name in object) {
						if (excludeAttributes.indexOf(name) === -1) {
							compareValues.push(name + '_' + this._getCompareString(object[name], excludeAttributes));
						}
					}
				}
				compareValues.sort();
				compareValues.forEach((value) => {
					compareString += value;
				});
			} else {
				compareString += object;
			}
			return compareString;
		}


		//query layer specific
		getRequestGroupKey(request) {
			let requestParams = request.requestParams;
			const sourceId = requestParams.sourceId || requestParams.sourceIdOrModule;
			return sourceId + '_' + (requestParams.querySpec.filters ? this._getCompareString(requestParams.querySpec.filters, []) : 'noFilters') + '_'+ JSON.stringify(requestParams.requestOptions)+ '_' + JSON.stringify(requestParams.senderId);
		}

		_getTableId(dataSource, dataItem) {
			const mdColumn =  dataSource.getMetadataColumn(dataItem.itemId);
			return mdColumn && mdColumn.getTableId();
		}
	}

	return GroupOptimizerBase;
});
